import React from 'react';
import { WhiteCheck } from 'src/assets/Images';
import { Column } from '../styles';
import { Text, Image } from './styles';
export var Success = function () { return (React.createElement(Column, { gap: "24px", className: "align-items-center" },
    React.createElement(Image, { src: WhiteCheck }),
    React.createElement(Column, { gap: "4px", className: "align-items-center" },
        React.createElement(Text, { className: "title" }, "Tu Mensaje fue enviado!"),
        React.createElement(Text, null, "Nos contactaremos en la brevedad")))); };
